import { useFeatureFlag } from "common/feature_gating";
import { isMobileDevice } from "util/support";

export function useIsMobileWebEnabled(): boolean {
  const captureEnabled = useFeatureFlag("persona-premeeting-capture");
  // Non-mobile users always get this. Otherwise, must persona be available
  return !isMobileDevice() || captureEnabled;
}
